module.exports = __webpack_public_path__ + "static/media/Faiz_SZ.be67de2d.jpg";